<template>
  <div>
    <v-container>
      <v-row>
        <v-col
          cols="12"
          md="4"
          v-for="field in params.fields"
          :key="field.name"
        >
          <v-text-field
            v-if="field.type == 'varchar'"
            v-model="fieldValues[field.name]"
            :label="field.label"
            required
            outlined
          />
          <v-autocomplete
            v-if="field.type == 'references' && isDeveloperReference(field)"
            :items="referencesData"
            item-text="transName"
            item-value="id"
            v-model="fieldValues[field.name]"
            required
            outlined
          />
          <v-select
            v-else-if="field.type == 'references'"
            :items="referencesData"
            item-text="transName"
            item-value="id"
            v-model="fieldValues[field.name]"
            required
            outlined
          />
          <v-textarea
            v-if="field.type == 'textarea'"
            v-model="fieldValues[field.name]"
            :label="field.label"
            outlined
            rounded
            height="100"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12">
          <v-btn @click="save" small outlined color="primary">
            {{ $t('Сохранить') }}
          </v-btn>
          <v-btn @click="cancel" class="ml-2" small outlined>
            {{ $t('Отмена') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import Appeal from '@/model/appeal'

  export default {
    props: {
      params: Object
    },
    data: () => ({
      load: false,
      fieldValues: {},
      referencesData: [],
      baseUrl: process.env.VUE_APP_BACK_URL
    }),
    mounted() {
      let self = this

      this.params.fields.forEach(function (field) {
        self.$set(self.fieldValues, field.name, field.value)
      })

      if (this.params.model) {
        Appeal.getReferencesData(this.params.model)
          .then((res) => this.referencesData = res.data)
          .catch((err) => console.log(err))
      }
    },
    methods: {
      isDeveloperReference(field) {
        if (!field) {
          return false
        }

        return field.name === 'whom' || this.params.model === 'whom'
      },
      save() {
        Appeal.updateAppeal(this.fieldValues, this.$route.params.id)
          .then((res) => {
            this.$emit('update-field', {
              status: true,
              fieldName: this.params.name,
              appeal: res.data.appeal
            })
          })
          .catch((err) => console.log(err))
      },
      cancel() {
        this.$emit('update-field', {
          status: true,
          fieldName: this.params.name
        })
      }
    }
  }
</script>
